import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import {useParams} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, ipAddress, userLocation, userName} from '../../Univ.js'
function OtNotes(props) {
    const {id} = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [surData, setSurData] = useState([]);
    const [postinDateTime, setPostinDateTime] = useState();
    const [postoutDateTime, setPostoutDateTime] = useState();
    const [preDateTime, setPreDateTime] = useState();
    const [postDateTime, setPostDateTime] = useState();
    const [anesDateTime, setAnesDateTime] = useState();
    const [otData, setotData] = useState({
        "pre_time": '',
        "pre_notes": '',
        "post_in": '',
        "post_out": '',
        "anes_time": '',
        "anes_notes": '',
        "post_time": '',
        "post_notes": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
    });
    const otFields = {
        PRE_OP: [
            {name: 'diagnosis', label: 'Diagnosis'},
            {name: 'procedure_planned', label: 'Procedure Planned'},
            {name: 'consent', label: 'Consent Taken'},
            {name: 'nil_by_mouth', label: 'NPO Status'},
            {name: 'vitals', label: 'Vitals'},
            {name: 'investigations', label: 'Investigations Reviewed'},
        ],
        ANESTHESIA: [
            {name: 'asa_grade', label: 'ASA Grade'},
            {name: 'airway', label: 'Airway Assessment'},
            {name: 'anesthesia_type', label: 'Type (GA/Spinal/Local)'},
            {name: 'drugs_used', label: 'Drugs Used'},
            {name: 'monitoring', label: 'Monitoring'},
        ],
        INTRA_OP: [
            {name: 'procedure_done', label: 'Procedure Done'},
            {name: 'findings', label: 'Intra-op Findings'},
            {name: 'blood_loss', label: 'Blood Loss'},
            {name: 'complications', label: 'Complications'},
        ],
        POST_OP: [
            {name: 'condition', label: 'Condition After Surgery'},
            {name: 'recovery', label: 'Recovery Status'},
            {name: 'post_orders', label: 'Post-op Orders'},
            {name: 'icu_needed', label: 'ICU Required'},
        ]
    };
    useEffect(() => {
        fetchsurData();
    }, []);
    function fetchsurData() {
        axios.get(baseUrl + "update-surgery/" + id + "/")
            .then(response => {
                const data = response.data;
                setSurData([data]);
                // 🔥 PARSE JSON FIELDS
                const preNotes = data.pre_notes ? JSON.parse(data.pre_notes) : {};
                const anesNotes = data.anes_notes ? JSON.parse(data.anes_notes) : {};
                const postNotes = data.post_notes ? JSON.parse(data.post_notes) : {};
                // 🔥 CONVERT INTO STATE FORMAT
                const formattedData = {};
                Object.keys(preNotes).forEach(key => {
                    formattedData[`pre_${key}`] = preNotes[key];
                });
                Object.keys(anesNotes).forEach(key => {
                    formattedData[`anes_${key}`] = anesNotes[key];
                });
                Object.keys(postNotes).forEach(key => {
                    formattedData[`post_${key}`] = postNotes[key];
                });
                console.log("🔥 Loaded OT Data:", formattedData);
                setotData(formattedData);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const handlepiDateTimeChange = (datetime) => {
        setPostinDateTime(datetime);
    };
    const handlepoDateTimeChange = (datetime) => {
        setPostoutDateTime(datetime);
    };
    const handlepreDateTimeChange = (datetime) => {
        setPreDateTime(datetime);
    };
    const handlepostDateTimeChange = (datetime) => {
        setPostDateTime(datetime);
    };
    const handleanesDateTimeChange = (datetime) => {
        setAnesDateTime(datetime);
    };
    const inputHandler = (event) => {
        const {name, value} = event.target;
        const updatedotData = {...otData, [name]: value};
        setotData(updatedotData);
    };
    const formSubmit = (e) => {
        e.preventDefault();
        const pre_time = document.getElementById("pre_time").value;
        const post_time = document.getElementById("post_time").value;
        const post_in = document.getElementById("post_in").value;
        const post_out = document.getElementById("post_out").value;
        const anes_time = document.getElementById("anes_time").value;
        const formData = new FormData();
        const preData = {};
        otFields.PRE_OP.forEach(field => {
            preData[field.name] = otData[`pre_${field.name}`] || '';
        });
        const anesData = {};
        otFields.ANESTHESIA.forEach(field => {
            anesData[field.name] = otData[`anes_${field.name}`] || '';
        });
        const postData = {};
        otFields.POST_OP.forEach(field => {
            postData[field.name] = otData[`post_${field.name}`] || '';
        });
        if (preData) {
            formData.append('pre_notes', JSON.stringify(preData));
        }
        if (pre_time) {
            formData.append('pre_time', pre_time);
        }
        if (post_time) {
            formData.append('post_time', post_time);
        }
        if (postData) {
            formData.append('post_notes', JSON.stringify(postData));
        }
        if (post_in) {
            formData.append('post_in', post_in);
        }
        if (post_out) {
            formData.append('post_out', post_out);
        }
        if (anesData) {
            formData.append('anes_notes', JSON.stringify(anesData));
        }
        if (anes_time) {
            formData.append('anes_time', anes_time);
        }
        formData.append('status', '1');
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
        formData.append('location', userLocation);
        axios.put(`${baseUrl}update-surgery/${id}/`, formData)
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    Swal.fire({
                        title: 'New Surgery has been added.',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    setTimeout(() => {
                        window.location.href = '/ot-notes-list/';
                    }, 2000);
                }
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed to add min entry. Please try again later.',
                    'error'
                );
            });
    };
    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{color: 'red'}}></i>
                Primary Consultant - Dr.{surData.map(row => row.ip.primary_consult.consultant)}
            </h3>
            <div className="table-responsive">
                <table className="erp-table-modern">
                    <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                        <th>Patient</th>
                        <th>IP ID</th>
                        <th>Patient ID</th>
                        <th>Patient Name</th>
                        <th>Gender</th>
                        <th>D.O.B/Age</th>
                        <th>Mobile</th>
                        <th>Regd. On</th>
                    </tr>
                    </thead>

                    <tbody>
                    {surData.map((patientData, index) => (
                        <tr>
                            <td><img src={patientData.ip.pat.profile_pic} alt="Thumbnail" className="thumbnail"
                                     style={{width: 120, height: 60}}/></td>
                            <td>{patientData.ip.ip_id}</td>
                            <td>{patientData.ip.pat.pat_id}</td>
                            <td>{patientData.ip.pat.patient}</td>
                            <td>{patientData.ip.pat.gender}</td>
                            <td>{patientData.ip.pat.age}</td>
                            <td>{patientData.ip.pat.mobile}</td>
                            <td>{patientData.ip.admit_date}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <div>
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                    <i className="fa-solid fa-scissors" aria-hidden="true" style={{color: 'red'}}></i>
                    OT Request
                </h3>
                <form>
                    <div className="row">
                        <div className="col-md-2 ms-1">
                            <label htmlFor="Pre OP Time" className="form-label">Pre OP Note Time : </label>
                            <DatePicker className="form-control" name="pre_time" id="pre_time"
                                        onChange={handlepreDateTimeChange.bind(this)}
                                        selected={surData.length > 0 && surData[0].pre_time ? new Date(surData[0].pre_time) : null || preDateTime}
                                        dateFormat="yyyy-MM-dd h:mm"
                                        showTimeSelect
                                        timeIntervals={15}
                                        timeCaption="Time"
                            />
                        </div>
                        <div className="col-md-6 ms-1">
                            <label htmlFor="Notes" className="form-label">Pre Operative Notes : </label>
                            {otFields.PRE_OP.map(field => (
                                <div className="col-md-12 mb-3" key={field.name}>
                                    <label className="form-label">{field.label}</label>

                                    <textarea
                                        className="form-control"
                                        name={`pre_${field.name}`}
                                        value={otData[`pre_${field.name}`] || ''}
                                        onChange={inputHandler}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2 ms-1">
                            <label htmlFor="Pre OP Time" className="form-label">Anesthesia Time : </label>
                            <DatePicker className="form-control" name="anes_time" id="anes_time"
                                        onChange={handleanesDateTimeChange}
                                        selected={surData.length > 0 && surData[0].anes_time ? new Date(surData[0].anes_time) : null || anesDateTime}
                                        dateFormat="yyyy-MM-dd h:mm"
                                        showTimeSelect
                                        timeIntervals={15}
                                        timeCaption="Time"
                            />
                        </div>
                        <div className="col-md-6 ms-1">
                            <label htmlFor="Notes" className="form-label">Anesthesia Notes : </label>
                            {otFields.ANESTHESIA.map(field => (
                                <div key={field.name} className="col-md-12 mb-3">
                                    <label>{field.label}</label>
                                    <textarea
                                        name={`anes_${field.name}`}
                                        value={otData[`anes_${field.name}`] || ''}
                                        onChange={inputHandler}
                                        className="form-control"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2 ms-1">
                            <label htmlFor="Post In Time" className="form-label">Post In Time : </label>
                            <DatePicker className="form-control" name="post_in" id="post_in"
                                        selected={surData.length > 0 && surData[0].post_in ? new Date(surData[0].post_in) : null || postinDateTime}
                                        onChange={handlepiDateTimeChange}
                                        dateFormat="yyyy-MM-dd h:mm"
                                        showTimeSelect
                                        timeIntervals={15}
                                        timeCaption="Time"
                            />
                        </div>
                        <div className="col-md-2 ms-1">
                            <label htmlFor="Post Out Time" className="form-label">Post Out Time : </label>
                            <DatePicker className="form-control" name="post_out" id="post_out"
                                        selected={surData.length > 0 && surData[0].post_out ? new Date(surData[0].post_out) : null || postoutDateTime}
                                        onChange={handlepoDateTimeChange}
                                        dateFormat="yyyy-MM-dd h:mm"
                                        showTimeSelect
                                        timeIntervals={15}
                                        timeCaption="Time"
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2 ms-1">
                            <label htmlFor="Post OP Time" className="form-label">Post OP Note Time : </label>
                            <DatePicker className="form-control" name="post_time" id="post_time"
                                        selected={surData.length > 0 && surData[0].post_time ? new Date(surData[0].post_time) : null || postDateTime}
                                        onChange={handlepostDateTimeChange}
                                        dateFormat="yyyy-MM-dd h:mm"
                                        showTimeSelect
                                        timeIntervals={15}
                                        timeCaption="Time"
                            />
                        </div>
                        <div className="col-md-6 ms-1">
                            <label htmlFor="Notes" className="form-label">Post Operative Notes : </label>
                            {otFields.POST_OP.map(field => (
                                <div key={field.name} className="col-md-12 mb-3">
                                    <label>{field.label}</label>
                                    <textarea
                                        name={`post_${field.name}`}
                                        value={otData[`post_${field.name}`] || ''}
                                        onChange={inputHandler}
                                        className="form-control"
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                    <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                         className='ms-5'>
                        <button type="button" onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
                    </div>
                </form>

            </div>
        </section>
    )
}
export default OtNotes;